import { jsx as a } from "react/jsx-runtime";
import { forwardRef as E, useRef as g, useImperativeHandle as v, useCallback as F } from "react";
import _ from "./index.es737.js";
import { LabeledField as k } from "./index.es494.js";
const w = "text-area", L = E(
  ({
    label: u,
    onChange: l,
    required: i,
    testId: c = w,
    feedback: n,
    isError: o = !1,
    asterix: m,
    value: d,
    infoTooltip: f,
    maxHeight: x,
    maxWidth: T,
    initialHeight: b,
    disabled: r,
    initialWidth: h,
    ...s
  }, p) => {
    const e = g(null);
    v(
      p,
      () => ({
        focus() {
          var t;
          (t = e == null ? void 0 : e.current) == null || t.focus();
        },
        blur() {
          var t;
          (t = e == null ? void 0 : e.current) == null || t.blur();
        },
        ...e.current
      }),
      []
    );
    const A = F(
      (t) => {
        l(t.target.value);
      },
      [l]
    );
    return /* @__PURE__ */ a(
      k,
      {
        label: u,
        feedback: r ? [] : n,
        required: i,
        isError: o,
        asterix: m,
        testId: `${c}-label`,
        infoTooltip: f,
        disabled: r,
        children: /* @__PURE__ */ a("div", { children: /* @__PURE__ */ a(
          "textarea",
          {
            className: _.textarea,
            value: d,
            required: o,
            onChange: A,
            "data-testid": c,
            ref: e,
            disabled: r,
            style: { maxHeight: x, maxWidth: T, height: b, width: h },
            "aria-label": s["aria-label"] || "Please Enter Text",
            ...s
          }
        ) })
      }
    );
  }
);
export {
  w as TEXT_AREA_DEFAULT_TESTID,
  L as TextAreaField
};
//# sourceMappingURL=index.es54.js.map
